// src/pages/TrackCreation/Step1.tsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RouteParamsWithLanguage, StoryTitleProps } from "../../../../../../types/screensTypes";
import Button from "../../../../../../components/ui/Button";
import { saveStory, getStoryById } from "../../../../../../api/museum";
import TitleSubtitle from "../../../../../../components/common/TitleSubtitle";
import TextInput from "../../../../../../components/ui/TextInput";
import { useTrackCreation } from "../../../../../../context/TrackCreationContext";
import { idToLanguage } from "../../../../../../utils/idtolanguage";
import { useGlobalState } from "../../../../../../context/useGlobalState";
import stepStyles from "../../../createStep.module.css";
import storyEdit from "./StoryEdit.module.css";

const StoryTitle: React.FC<StoryTitleProps> = ({ navigateToNext }) => {
    const { storyId, planId, language } = useParams<RouteParamsWithLanguage>(); // Get storyId, planId, and language from the URL
    const [title, setTitle] = useState<string>("");
    const { trackData } = useTrackCreation();
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const { data } = useGlobalState();
    const saveStoryAPI = async (): Promise<void> => {
        const token = localStorage.getItem("token"); // Retrieve token
        const trackId = trackData.trackId;
        if (!token || !trackId || !storyId || !planId || !language) {
            return;
        }
        const tempWpt = await saveStory({
            token,
            trackId,
            clickableZoneId: storyId,
            subplanId: planId,
            language,
            name: title,
        });
        if (tempWpt && tempWpt.clickableZoneId) {
            const id: string = tempWpt.clickableZoneId;
            navigateToNext(id, language, planId);
        }
    };

    const getStoryAPI = async (): Promise<void> => {
        const token = localStorage.getItem("token");
        const trackId = trackData.trackId;
        if (!token || !trackId || !storyId || !language) {
            return;
        }

        const storyData = await getStoryById({
            token,
            trackId,
            clickableZoneId: storyId,
            language,
        });
        if (storyData) {
            const localizedData = storyData.clickableZonesLocalized;
            if (localizedData && localizedData.length > 0) {
                const title = localizedData[0].name;
                setTitle(title);
            }
        }
    };

    useEffect(() => {
        if (storyId && storyId !== "") {
            getStoryAPI();
        }
    }, [storyId, language]);

    return (
        <div>
            <TitleSubtitle
                title={t("storyTitle") + idToLanguage(language ? language : "", data?.languagesAI, t)}
                subtitle={""}
                layout="step"
            />
            <div className={storyEdit.titleField}>
                <TextInput
                    placeholder={t("title")}
                    value={title}
                    size="small"
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>
            <div className={stepStyles.stepButton}>
                <Button
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                    label={t("continue")}
                    onClick={async () => {
                        await saveStoryAPI();
                    }}
                />
            </div>
        </div>
    );
};

export default StoryTitle;
